import { applyDocumentMask } from '@clickersphere/core/utils/documentMask';
import { Input } from './Input';

interface IDocumentInputProps {
  name: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  error?: string;
  disabled?: boolean;
}

export default function DocumentInput({
  name,
  value,
  onChange,
  placeholder,
  error,
  disabled,
}: IDocumentInputProps) {
  return (
    <Input
      name={name}
      inputMode="numeric"
      maxLength={18}
      value={value}
      onChange={(e) => onChange(applyDocumentMask(e.target.value))}
      placeholder={placeholder}
      error={error}
      disabled={disabled}
    />
  );
}
